import React from 'react';
import { find } from 'lodash-es';
import { TUserSelection, IProduct } from '../../types/PDP';
import { hasHiddenInventoryTag } from 'src/scripts/utils/plp-pdp-shared';
import { checkIfItemCanBeSoldOut } from 'src/scripts/utils/helpers';

//we need to reuse this for quickview...

export const UserSelection = (props: {
  value: string;
  productUid: number;
  optionName: 'Color' | 'Size';
  product: IProduct;
  userSelection: TUserSelection;
  onSelect: () => void;
  uiRender?: (props: { notAvailableForSale: boolean }) => JSX.Element;
  children?: JSX.Element;
  isMobile?: boolean;
}) => {
  const { optionName, productUid, value, product, userSelection, onSelect, uiRender, children } = props;
  const colorData = product.productDataByColorName[value];
  const selectionVariant = find(product.variants, { selectionOptions: { ...userSelection, [optionName]: value } });
  const madeSelection = optionName === 'Size' || (!!userSelection.Color && !!userSelection.Size);
  const notAvailableForSale = madeSelection && (!selectionVariant || !selectionVariant.availableForSale);
  const shouldHideInventory = hasHiddenInventoryTag(product.productDataByColorName[value]?.tags);
  // ? [REVISIT] what do when we have none; can products not have `inventory`?
  const totalInventory = colorData?.totalInventory;
  const isSoldOutCompletely = checkIfItemCanBeSoldOut(product.productDataByColorName[value]?.tags)
    ? typeof totalInventory === 'number' && totalInventory <= 0
    : false;

  // * [IMPROVEMENT] why all the wrapping? & noisy html elements ... simplify DOM structure/UI
  const uidStr = `Swatch-${optionName}-${productUid}-${value}`;
  const isActive = value === userSelection[optionName];

  const isDisabled = isSoldOutCompletely || notAvailableForSale || shouldHideInventory;
  return (
    <label
      className={`UserSelection square option-${optionName} ${isActive ? 'active' : ''}`}
      data-disabled={isDisabled}
      htmlFor={uidStr}
      role="button"
      aria-pressed={isActive}
      aria-label={`${value}${isDisabled ? ' is not available' : ''}`}
      tabIndex={0}
      onKeyDown={(event) => {
        if (['Enter', ' '].includes(event.key)) {
          event.preventDefault();
          onSelect();
        }
      }}
    >
      <input
        className={optionName}
        type="radio"
        name={`${productUid}-${optionName}`}
        id={uidStr}
        tabIndex={-1}
        value={value}
        checked={isActive}
        onChange={onSelect}
      />
      {uiRender ? uiRender({ notAvailableForSale }) : children}
    </label>
  );
};
